import { useEffect, useState } from 'react';

export const OVERDUE_AFTER_MINUTES = 30;
const TICK_MS = 60_000;

export function doseOverdue(dose: { status: string; scheduledAt: string; overdue?: boolean }, nowMs: number): boolean {
  if (dose.status !== 'due') return false;
  if (dose.overdue) return true;
  const scheduled = Date.parse(dose.scheduledAt);
  return Number.isFinite(scheduled) && scheduled < nowMs - OVERDUE_AFTER_MINUTES * 60_000;
}

export function useMinuteClock(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = null;
    const start = () => {
      if (interval) return;
      setNow(Date.now());
      interval = setInterval(() => setNow(Date.now()), TICK_MS);
    };
    const stop = () => {
      if (interval) clearInterval(interval);
      interval = null;
    };
    const onVisibility = () => (document.visibilityState === 'visible' ? start() : stop());
    onVisibility();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);
  return now;
}
